module.exports = __webpack_public_path__ + "img/icon_fp_link5.83cd9883.svg";